import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ErrorBoundary, ProtectedRoute } from './components/common';
import { Layout } from './components/layout';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { ROUTES } from './constants';
import {
  LoginPage,
  OtpVerificationPage,
  DashboardPage,
  MarketersPage,
  MarketerDetailPage,
  MerchantsPage,
  MerchantDetailPage,
  UsersPage,
  RolesPage,
  ProfilePage,
  TopupCashbackPage,
  OneSnapTransactionsPage,
  OneSnapTransactionDetailPage,
  ReversalTransactionsPage,
  ReversalTransactionDetailPage,
} from './pages';

const NotFound = () => (
  <div className='min-h-screen flex items-center justify-center bg-gray-50'>
    <div className='text-center'>
      <h1 className='text-2xl font-bold text-gray-900'>404 - Page Not Found</h1>
      <p className='text-gray-600'>
        The page you're looking for doesn't exist.
      </p>
    </div>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path={ROUTES.LOGIN} element={<LoginPage />} />
              <Route
                path={ROUTES.OTP_VERIFICATION}
                element={<OtpVerificationPage />}
              />

              {/* Protected routes with layout */}
              <Route
                path={ROUTES.DASHBOARD}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DashboardPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.MARKETERS_DETAIL_LIST}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MarketerDetailPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.MARKETERS}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MarketersPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.TOPUP_CASHBACK}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <TopupCashbackPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ONE_SNAP}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <OneSnapTransactionsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ONE_SNAP_DETAIL}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <OneSnapTransactionDetailPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.REVERSAL}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ReversalTransactionsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.REVERSAL_DETAIL}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ReversalTransactionDetailPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.MERCHANTS}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MerchantsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.MERCHANTS_DETAIL}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <MerchantDetailPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.USERS}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <UsersPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.ROLES}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <RolesPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path={ROUTES.PROFILE}
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ProfilePage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              {/* Root route redirects to dashboard */}
              <Route
                path='/'
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DashboardPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              {/* Error routes */}
              <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
          </Router>
        </AppProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
